import React, { useEffect, useRef, useState } from "react";
import { useContent } from "@/lib/useContent";

const CountUp = ({ value, suffix }) => {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      const start = performance.now();
      const dur = 1800;
      const tick = (now) => {
        const p = Math.min((now - start) / dur, 1);
        setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
};

export const Counters = () => {
  const stats = useContent("stats");
  return (
    <section className="py-20 bg-[#0A2E4D]" data-testid="counters-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 text-center">
        {stats.map((c) => (
          <div key={c.label}>
            <div className="font-serif-display text-4xl lg:text-5xl text-[#E3BA45]"><CountUp value={Number(c.value) || 0} suffix={c.suffix} /></div>
            <div className="text-white/70 text-xs uppercase tracking-[0.2em] mt-3 font-semibold">{c.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
